// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;
}

.breadcrumb-item,
.delimeter {
  font-family: "Poppins", serif;
  font-size: 14px;
  font-weight: 600;
  color: #676767;
}

.breadcrumb-item {
  cursor: pointer;
}

.breadcrumb-item:last-child {
  cursor: default;
  color: #67676796;
}

.youtube .card-title {
  color: var(--primary-300, #f45c7b);
  font-size: 18px;
}

.youtube-container{
  flex: 1 1;
  background: #fff;
  box-sizing: border-box;
  padding: 10px;
  /* padding-top: 20px; */
  border-radius: 0.5rem;
  height: 100%;
}

.right-top-actions {
  display: flex;
  align-items: center;
  gap: 4px;

  color: #000;

  cursor: pointer;
}

.right-top-actions span {
  font-family: "Poppins", serif;
  font-size: 12px;
  font-weight: 400;
}

.no-data,
.loading-container {
  min-height: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Brand/Insights/Youtube/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,WAAW;;EAEX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB","sourcesContent":[".breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.breadcrumb-item,\n.delimeter {\n  font-family: \"Poppins\", serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #676767;\n}\n\n.breadcrumb-item {\n  cursor: pointer;\n}\n\n.breadcrumb-item:last-child {\n  cursor: default;\n  color: #67676796;\n}\n\n.youtube .card-title {\n  color: var(--primary-300, #f45c7b);\n  font-size: 18px;\n}\n\n.youtube-container{\n  flex: 1;\n  background: #fff;\n  box-sizing: border-box;\n  padding: 10px;\n  /* padding-top: 20px; */\n  border-radius: 0.5rem;\n  height: 100%;\n}\n\n.right-top-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #000;\n\n  cursor: pointer;\n}\n\n.right-top-actions span {\n  font-family: \"Poppins\", serif;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.no-data,\n.loading-container {\n  min-height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
